/* app/js/src/components/media-transcoder/jobs/packager/packager.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.packager-jobs-container .filters-bar .name-filter-input {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border-radius: 4px;
  background-color: #ffffff;
  height: 30px;
  border: 1px solid #e1e6eb;
  line-height: 2.2em;
  font-size: 0.9em;
  padding: 0 15px;
  color: #232f3a;
}
.packager-jobs-container .filters-bar .name-filter-input:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
.packager-jobs-container .filters-bar .name-filter-input::-webkit-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.packager-jobs-container .filters-bar .name-filter-input:-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.packager-jobs-container .filters-bar .name-filter-input::-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.packager-jobs-container .filters-bar .name-filter-input:-ms-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.packager-jobs-container .filters-bar .ng-invalid.ng-dirty.name-filter-input,
.packager-jobs-container .filters-bar .ng-invalid.ng-touched.name-filter-input {
  border-color: #ef5350;
}
.flex {
  display: flex;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.row {
  flex-direction: row;
}
.flex.column {
  flex-direction: column;
}
.flex.space-between {
  justify-content: space-between;
}
.flex.space-around {
  justify-content: space-around;
}
.flex.justify-center {
  justify-content: center;
}
.flex.justify-end {
  justify-content: end;
}
.flex.justify-evenly {
  justify-content: space-evenly;
}
.flex.align-items-center {
  align-items: center;
}
.flex.fill-width {
  width: 100%;
}
.flex.fill-height {
  height: 100%;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.align-items-baseline {
  align-items: baseline;
}
.flex.red {
  background-color: red;
}
.flex.blue {
  background-color: blue;
}
:host {
  display: block;
  position: relative;
  min-height: 180px;
  max-width: 100%;
  overflow: hidden;
}
.packager-jobs-container {
  margin-top: 1vw;
  max-width: 100%;
  box-sizing: border-box;
}
.packager-jobs-container .filters-bar {
  align-items: center;
  gap: 1.5vw;
  margin-bottom: 1vw;
  flex-wrap: wrap;
}
.packager-jobs-container .filters-bar .filter-group {
  display: flex;
  align-items: center;
  gap: 0.75vw;
  flex: 0 0 auto;
}
.packager-jobs-container .filters-bar .filter-group.bulk-action {
  margin-left: auto;
}
.packager-jobs-container .filters-bar .filter-label {
  color: #232f3a;
  font-weight: 600;
  flex: 0 0 auto;
  line-height: 30px;
}
.packager-jobs-container .filters-bar .name-filter-input {
  width: 14rem;
  min-width: 14rem;
  height: 30px;
  box-sizing: border-box;
  margin: 0;
  line-height: 30px;
  padding: 0 15px;
}
.packager-jobs-container .filters-bar ::ng-deep icn-dropdown.filter-dropdown {
  display: inline-block;
  width: 14rem !important;
  min-width: 14rem;
  height: 30px !important;
  vertical-align: middle;
}
.packager-jobs-container .filters-bar ::ng-deep icn-dropdown.filter-dropdown .main-container {
  height: 100%;
}
.packager-jobs-container .filters-bar ::ng-deep icn-dropdown.filter-dropdown .selected-container {
  height: 30px;
  line-height: 30px;
  box-sizing: border-box;
}
.packager-jobs-container .table-wrapper {
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
}
.packager-jobs-container .jobs-table {
  width: 100%;
  max-width: 100%;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;
  color: #232f3a;
}
.packager-jobs-container .jobs-table tr:nth-child(odd) {
  background-color: #fdfdfd;
}
.packager-jobs-container .jobs-table tbody tr:hover {
  background-color: #e7dfdf;
}
.packager-jobs-container .jobs-table th {
  border-bottom: 1px solid #232f3a;
}
.packager-jobs-container .jobs-table th,
.packager-jobs-container .jobs-table td {
  height: 2vw;
  min-height: 2rem;
  padding: 0 0.75vw;
  text-align: left;
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
}
.packager-jobs-container .jobs-table th:nth-child(1),
.packager-jobs-container .jobs-table td:nth-child(1) {
  width: 18%;
  word-break: break-word;
  white-space: normal;
}
.packager-jobs-container .jobs-table th:nth-child(2),
.packager-jobs-container .jobs-table td:nth-child(2) {
  width: 10%;
  white-space: nowrap;
}
.packager-jobs-container .jobs-table th:nth-child(3),
.packager-jobs-container .jobs-table td:nth-child(3),
.packager-jobs-container .jobs-table th:nth-child(4),
.packager-jobs-container .jobs-table td:nth-child(4) {
  width: 14%;
  white-space: nowrap;
}
.packager-jobs-container .jobs-table th:nth-child(5),
.packager-jobs-container .jobs-table td:nth-child(5) {
  width: 38%;
  white-space: nowrap;
}
.packager-jobs-container .jobs-table th:nth-child(6),
.packager-jobs-container .jobs-table td:nth-child(6) {
  width: 6%;
  min-width: 4.5rem;
  white-space: nowrap;
}
.packager-jobs-container .jobs-table .status-cell {
  text-transform: capitalize;
  color: #232f3a;
}
.packager-jobs-container .jobs-table .path-cell {
  font-size: 0.85em;
}
.packager-jobs-container .jobs-table td > a,
.packager-jobs-container .jobs-table td.actions-cell > span {
  color: #40c4ff;
  cursor: pointer;
  text-decoration: none;
}
.packager-jobs-container .jobs-table td > a:hover,
.packager-jobs-container .jobs-table td.actions-cell > span:hover {
  text-decoration: underline;
}
:host ::ng-deep .packager-bulk-modal .nsm-dialog-btn-close {
  display: none !important;
}
/*# sourceMappingURL=packager.component.css.map */
